export default __webpack_public_path__ + "static/media/pancreas4.c138af85.jpg";